'use strict';

var __chunk_1 = require('./chunk-ba04ad2f.js');

function dropWhile(p, as) {
  var s = __chunk_1.isString(as) ? '' : [];
  var m = as.length;
  var n = 0;

  while (n < m && p(as[n])) {
    n++;
  }

  for (var i = n; i < m; i++) {
    s = s.concat(as[i]);
  }

  return s;
}

module.exports = dropWhile;
